<template>
  <div class="container">
    <md-card class="chat-container">
      <div class="conversation-header">
        <div class="d-flex align-items-center gap-2 px-3 py-2">
          <md-button class="md-icon-button md-dense" @click="$router.go(-1)">
            <md-icon>arrow_back</md-icon>
          </md-button>
          <div>
            <h2 class="md-title mb-0">Conversation Details</h2>
            <div class="participants">
              Between:
              <span class="participant">{{ participantDetails.customer }}</span>
              and
              <span class="participant">{{
                participantDetails.professional
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="loader" v-if="loading">
        <Wave width="50px" color="#d9534f" />
      </div>

      <md-card-content class="chat-content">
        <div class="messages-container">
          <div
            v-for="message in conversations"
            :key="message.id"
            class="message"
            :class="getMessageClass(message)"
          >
            <div class="message-header">
              <strong>{{ getParticipantRole(message.sender_id) }}</strong>
              <small>{{ message.created_at | formatDate }}</small>
            </div>
            <div class="message-bubble">
              {{ message.content }}
            </div>
            <div class="message-status" v-if="message.read_at">
              <small>Read: {{ message.read_at | formatDate }}</small>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { PageHeader, Wave } from "@/components";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("offer");

export default {
  name: "OffersConversation",
  components: {
    Wave
  },
  data: () => ({
    participantDetails: {
      customer: "",
      professional: ""
    }
  }),
  methods: {
    ...mapActions(["getConversations"]),
    getMessageClass(message) {
      return {
        "message-customer":
          message.sender_id === this.conversations[0]?.sender_id,
        "message-professional":
          message.sender_id === this.conversations[0]?.receiver_id
      };
    },
    getParticipantRole(senderId) {
      if (senderId === this.conversations[0]?.sender_id) {
        return "Customer";
      }
      return "Professional";
    },
    setParticipantDetails() {
      if (this.conversations.length > 0) {
        const firstMessage = this.conversations[0];
        this.participantDetails = {
          customer: `${firstMessage.sender.first_name} ${firstMessage.sender.last_name}`,
          professional: `${firstMessage.receiver.first_name} ${firstMessage.receiver.last_name}`
        };
      }
    }
  },
  watch: {
    conversations: {
      handler: "setParticipantDetails",
      immediate: true
    }
  },
  mounted() {
    const conversationId = this.$route.params.id;
    this.getConversations(conversationId);
  },
  computed: {
    ...mapGetters(["loading", "conversations"])
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  height: calc(100vh - 100px);
}

.chat-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chat-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: #f5f5f5;
}

.messages-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message {
  max-width: 70%;
  margin: 4px 0;

  &-customer {
    align-self: flex-start;
    .message-bubble {
      background-color: #e3f2fd;
      border-radius: 12px 12px 12px 0;
    }
  }

  &-professional {
    align-self: flex-end;
    .message-bubble {
      background-color: #f5f5f5;
      border-radius: 12px 12px 0 12px;
    }
  }

  &-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    font-size: 0.9em;

    small {
      color: #666;
    }
  }

  &-bubble {
    padding: 12px 16px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    word-break: break-word;
  }

  &-status {
    display: flex;
    justify-content: flex-end;
    color: #8e8e8e;
    font-size: 0.8em;
    margin-top: 2px;
  }
}

.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.conversation-header {
  border-bottom: 1px solid #eee;

  .participants {
    font-size: 0.9rem;
    color: #666;
    margin-top: 4px;
  }

  .participant {
    font-weight: 500;
    color: #333;
  }
}
</style>
